<template>
  <div class="OrderView">
      <User />
  </div>
</template>

<script>
import User from '@/components/User.vue'

export default {
  name: 'OrderView',
  components: {
    User
  }
}
</script>
